import React from "react";
import { AccentDialog } from "./AccentDialog";
import { AccentButton } from "../controls/AccentButton";
import AccentIcons from "../icons/Icons";
import { t } from "../services/HelperService";
import "./SendMethodDlg.css";

export default function SendMethodDlg ({ onClose }) {
    const [selectedMethod, setSelectedMethod] = React.useState(null);

    const handleContinue = () => {
        if (!selectedMethod) return;
        onClose({ method: selectedMethod, canceled: false });
    };

    const handleCancel = () => {
        onClose({ canceled: true });
    };

    return (
        <AccentDialog
            id="dlg-send-quote-method"
            headerContent={<strong>{t("application_strings.application.dialogs.sendMethodDlg.sendQuote")}</strong>}
            minWidth={500}
            maxWidth={600}
            onClose={handleCancel}
            actionsContent={[
                <AccentButton
                    key="continue"
                    onClick={handleContinue}
                    disabled={!selectedMethod}
                >
                    {t("application_strings.application.buttons.next")}
                </AccentButton>,
            ]}
        >
            <div className="send-quote-method-container">
                <p className="send-quote-method-description">
                    {t("application_strings.application.dialogs.sendMethodDlg.description")}
                </p>

                <div className="send-quote-method-options">
                    {/* Email Option */}
                    <div
                        className={`send-quote-method-card ${selectedMethod === 'email' ? 'selected' : ''}`}
                        onClick={() => setSelectedMethod('email')}
                    >
                        <div className="send-quote-method-icon email-icon">
                            <AccentIcons.Email style={{ fontSize: '32px' }} />
                        </div>
                        <div className="send-quote-method-content">
                            <h4 className="send-quote-method-title">
                                {t("application_strings.application.dialogs.sendMethodDlg.emailTitle")}
                            </h4>
                            <p className="send-quote-method-text">
                                {t("application_strings.application.dialogs.sendMethodDlg.emailDescription")}
                            </p>
                        </div>
                        {selectedMethod === 'email' && (
                            <div className="send-quote-method-checkmark">
                                <span>✓</span>
                            </div>
                        )}
                    </div>

                    {/* WhatsApp Option */}
                    <div
                        className={`send-quote-method-card ${selectedMethod === 'whatsapp' ? 'selected' : ''}`}
                        onClick={() => setSelectedMethod('whatsapp')}
                    >
                        <div className="send-quote-method-icon whatsapp-icon">
                            <AccentIcons.WhatsAppIconOnlyWhiteOnGreenSmall
                                style={{ width: 32, height: 32 }}
                            />
                        </div>
                        <div className="send-quote-method-content">
                            <h4 className="send-quote-method-title">
                                {t("application_strings.application.dialogs.sendMethodDlg.whatsAppTitle")}
                            </h4>
                            <p className="send-quote-method-text">
                                {t("application_strings.application.dialogs.sendMethodDlg.whatsAppDescription")}
                            </p>
                        </div>
                        {selectedMethod === 'whatsapp' && (
                            <div className="send-quote-method-checkmark">
                                <span>✓</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </AccentDialog>
    );
}